export default __webpack_public_path__ + "static/header-video-7cce45815f4072a21a6c9632e43c05ff.mp4";